<template>
  <div class="login-bg">
    <div class="login-panel">
      <h2 class="login-title">AI⁺智慧养老健康平台</h2>
      <form class="form-wrap" @submit.prevent="onSubmit">
        <div class="input-group">
          <img src="@/assets/user.png" class="input-icon" alt="账号" />
          <input
            v-model="form.username"
            type="text"
            placeholder="请输入账号"
            autocomplete="username"
            required
          />
        </div>
        <div class="input-group">
          <img src="@/assets/password.png" class="input-icon" alt="密码" />
          <input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            autocomplete="current-password"
            required
          />
        </div>
        <div class="captcha-row">
          <div class="input-group captcha-input-group">
            <input
              v-model="form.captcha"
              type="text"
              placeholder="请输入验证码"
              autocomplete="off"
              required
              class="captcha-input"
            />
          </div>
          <div class="captcha-image" @click="getCaptcha" style="margin-top: -5px">
            <!-- <img style="width: 100px; height: 40px" :src="captchaImage"/> -->
            <img :src="captchaImg" alt="验证码" class="captcha-img" />
          </div>
        </div>
        <!-- <div class="options">
          <label>
            <input type="checkbox" v-model="form.remember" />
            记住密码
          </label>
          <a href="#" class="forgot">忘记密码</a>
        </div> -->
        <button class="login-btn" type="submit">登录</button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getCaptchaApi } from '../api/login';
import { getAuthToken } from '../api/auth';
import { ElMessage } from 'element-plus';
import { encrypt } from '../utils/tools';
import { useUserStore } from '../store/user';
import { isTokenValid } from '../service/TokenManage';
// @ts-ignore 临时忽略 js-cookie 缺少类型声明的问题
import Cookies from 'js-cookie';

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const form = reactive({
  username: '',
  password: '',
  captcha: '',
  remember: true
});
const key = ref('thanks,acc4cloud'); // 16字节密钥
const iv = ref('thanks,acc4cloud'); // 16字节初始化向量
const captchaImg = ref('');
const randomNum = ref('');

async function getCaptcha() {
  randomNum.value = Math.floor(Math.random() * 10000000000).toString();
  const res = await getCaptchaApi(randomNum.value);

  // 由于设置了responseType: 'blob'，res.data就是Blob对象
  const blobData = res.data as unknown as Blob;
  captchaImg.value = URL.createObjectURL(blobData);
}

getCaptcha();

async function onSubmit() {
  try {
    const passwd = encrypt(key.value, iv.value, form.password);
    const res = await getAuthToken({
      username: form.username,
      password: passwd,
      scope: 'server',
      grant_type: 'password',
      code: form.captcha,
      randomStr: randomNum.value
    });

    if ((res as any).access_token) {
      // 使用临时token获取用户信息
      const tempToken = (res as any).access_token;

      // 使用新的 setTempToken action，只设置内存token，不保存到storage
      userStore.setTempToken(tempToken);

      // 设置全局token变量，供HTTP拦截器使用
      window.__CURRENT_TOKEN__ = tempToken;

      // 获取用户信息来获得userId
      const userInfo = await userStore.fetchUserInfo();

      if (userInfo) {
        // 现在有了userId上下文，再次通过action正确保存token到storage
        userStore.setToken(tempToken);
        console.log(tempToken, 'tempToken')
        const hostname = window.location.hostname;
        const cookieOptions =
          hostname === 'aiot-qa.zuowei.com' || hostname.endsWith('.aiot-qa.zuowei.com')
            ? { domain: 'aiot-qa.zuowei.com', path: '/' }
            : hostname === 'aiot.zuowei.com' || hostname.endsWith('.aiot.zuowei.com')
              ? { domain: 'aiot.zuowei.com', path: '/' }
              : { path: '/' };
        Cookies.set('token', tempToken, cookieOptions);

        // 清除全局变量，因为token已经保存到storage中
        delete window.__CURRENT_TOKEN__;

        // 等待一下确保保存完成
        await new Promise(resolve => setTimeout(resolve, 100));

        // 验证token是否正确保存
        const tokenValid = isTokenValid();

        if (!tokenValid) {
          console.error('❗ TokenManage显示token无效，检查userId上下文');
          ElMessage.error('认证状态异常，请重新登录');
          getCaptcha();
          return;
        }

        ElMessage.success({ message: '登录成功，正在跳转...', duration: 1000 });

        // 跳转逻辑
        setTimeout(() => {
          const redirect = route.query.redirect as string;
          const targetRoute = redirect || '/';

          router.push(targetRoute).catch(() => {
            router.replace(targetRoute).catch(() => {
              window.location.href = targetRoute;
            });
          });
        }, 500);
      } else {
        // 获取用户信息失败，清除全局token
        delete window.__CURRENT_TOKEN__;
        ElMessage.error('获取用户信息失败，请重试');
        getCaptcha();
      }
    } else {
      ElMessage.error(res.msg || '登录失败');
      getCaptcha();
    }
  } catch (error) {
    // 清除全局token
    delete window.__CURRENT_TOKEN__;
    ElMessage.error((error as Error).message || String(error));
    getCaptcha();
  }
}
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  width: 100vw;
  padding-left: 10%;
  background: url('@/assets/3DAI.gif') no-repeat center center/100% 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}

.login-panel {
  z-index: 2;
  width: 562px;
  height: 608px;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 8px 32px rgba(0, 60, 255, 0.08);
  padding: 48px 40px 40px 40px;
  /* display: flex;
  flex-direction: column; */
}
.login-title {
  color: #2986dc;
  font-size: 44px;
  font-weight: bold;
  font-family: 'SourceHanSansCN-Bold';
  line-height: 75px;
  margin-bottom: 50px;
  text-align: center;
  letter-spacing: 1px;
}
.form-wrap {
  width: 100%;
  padding: 0 46px;
}
.input-group {
  display: flex;
  align-items: center;
  background: #f5f8fa;
  border-radius: 24px;
  padding: 0 16px;
  margin-bottom: 18px;
  height: 58px;
}
.input-icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  opacity: 0.7;
}
.input-group input {
  height: 32px;
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-size: 16px;
  color: #333;
}
.captcha-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.captcha-input-group {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f5f8fa;
  border-radius: 24px;
  padding: 0 16px;
  height: 46px;
}
.captcha-input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-size: 16px;
  color: #333;
}
.captcha-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
}
.captcha-img {
  width: 100px;
  height: 40px;
  cursor: pointer;
  margin-left: 16px;
}
.options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  font-size: 14px;
  color: #2986dc;
}
.options label {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #2986dc;
}
.options .forgot {
  color: #999;
  text-decoration: none;
  font-size: 14px;
}
.login-btn {
  width: 390px;
  height: 58px;
  background: #2986dc;
  color: #fff;
  border: none;
  border-radius: 29px;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
}
.login-btn:hover {
  background: #1760c4;
}
</style>
